import request from '@/utils/request'
import baseUrl from '@/api/baseUrl'

export default {

	/**
	 * 定时投屏列表
	 * @param {page} 第几页
	 * @return {pageSize} 每页数量
	**/
	programTaskList( params={} ) {
		return request({
	    url: baseUrl + '/screen/programTask',
	    method: 'GET',
	    params
	  })
	},

	/**
	 * 定时投屏修改
	**/
	programTaskEdit(id,data){
		return request({
			url: baseUrl + '/screen/programTask/'+id,
			method:'PUT',
			data
		})
	},
	/**
	 * 定时投屏删除
	**/
	programTaskDel(id){
		return request({
			url: baseUrl + '/screen/programTask/'+id,
			method:'DELETE'
		})
	},

	/**
	 * 定时投屏添加
	**/
	programTaskAdd(data){
		return request({
			url: baseUrl + '/screen/programTask',
			method:'POST',
			data
		})
	},

	/**
	 * 定时投屏 是否开启
	 * @param {plan_id} 计划id
	 * @return {ste} 0关闭1开启
	**/
	programTaskSet(data){
		return request({
			url: baseUrl + '/screen/programTaskSet',
			method:'POST',
			data
		})
	}
}